<template>
  <Wrapper :back="{ name: 'emojis' }">
    <template slot="header">
      {{ $t('views.categories.title') }}
    </template>

    <CategoriesContent
      :categories="categories"
      :selected-categories="selectedCategories"
      :is-netguru-mode="isNetguruMode"
      @onToggle="toggleCategory"
    />

    <template slot="footer">
      <button
        class="btn btnPrimary"
        :class="{
          'is-disabled': selectedCategories.length === 0,
        }"
        @click="startGame"
      >
        {{ $t('views.categories.play') }}
      </button>
      <button @click="$_redirectWithSound({ name: 'onboarding' })">
        {{ $t('views.categories.game_rules') }}
      </button>
    </template>
  </Wrapper>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import Wrapper from '@/components/Wrapper/Wrapper';
import CategoriesContent from '@/components/CategoriesContent/CategoriesContent';
import { categories } from '@/consts';

export default {
  components: {
    Wrapper,
    CategoriesContent,
  },

  data() {
    return {
      categories,
    };
  },

  computed: {
    ...mapState('settings', ['selectedCategories']),
    ...mapGetters('settings', ['isNetguruMode']),
  },

  methods: {
    ...mapMutations('settings', ['toggleCategory']),
    startGame() {
      this.$store.dispatch('prepareGame');
      this.$_redirectWithSound({ name: 'game' });
    },
  },
};
</script>
